module.exports = __webpack_public_path__ + "img/badge-list-thumb-113.26884ac3.png";